import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.625 3C17.8917 3 18.1504 3.05039 18.4004 3.15039C18.6501 3.25034 18.8666 3.39989 19.0498 3.59961L20.4248 5C20.6248 5.18333 20.7706 5.40039 20.8623 5.65039C20.9539 5.9003 21 6.15048 21 6.40039C21 6.66681 20.9539 6.92064 20.8623 7.16211C20.7706 7.40378 20.6248 7.6252 20.4248 7.8252L7.25 21H3V16.75L16.2002 3.5752C16.4001 3.39194 16.6208 3.25038 16.8623 3.15039C17.104 3.05039 17.3583 3 17.625 3ZM5 17.5752V19H6.4248L16.2002 9.22461L15.4746 8.52539L14.7754 7.7998L5 17.5752Z" })
});
export default SvgPencil;
